import {Options} from "highcharts";
import {registerPlugin} from "surveylabJsAssets/chart/charts";
import {BaseChart, ChartSettings} from "./base-chart";

export class PercentageChart extends BaseChart {
    protected getValues(data: Array<any>): Array<any> {
        let values = [];
        for (let i = 0; i < data.length; i++) {
            const value = data[i]['value'];
            if (value < 33) {
                values.push({y: value, color: '#f3ca4e'});
            } else if (value < 66) {
                values.push({y: value, color: '#3b90e7'});
            } else {
                values.push({y: value, color: '#00a822'});
            }
        }
        return values;
    }

    protected allChartOptions(): Options {
        const addBarLabels = this.addBarLabels;
        const customSettings: ChartSettings = $(this.target).data('chart-settings');
        const seriesData: Array<any> = $(this.target).data('chart');
        const options: Options = {
            chart: {
                events: {
                    load: function () {
                        addBarLabels(seriesData, this.renderer);
                    }
                }
            },
            series: [
                {
                    type: 'bar',
                    data: this.getValues(seriesData)
                }
            ],
            yAxis: {
                min : 0,
                max : 100,
                plotLines: [
                    {
                        value: 33,
                        color: 'grey',
                        width: 1,
                        zIndex: 1,
                        dashStyle: 'Dot'
                    }, {
                        value: 66,
                        color: 'grey',
                        width: 1,
                        zIndex: 1,
                        dashStyle: 'Dot'
                    }
                ],
                plotBands: [
                    {
                        color: 'rgba(243, 202, 78, 0.1)',
                        from: 0,
                        to: 33,
                        label : {
                            text : customSettings.legend.improvableLabel,
                            verticalAlign: 'bottom',
                            useHTML: true,
                            x: -8,
                            style: {
                                fontSize: '10pt',
                                color: '#f3ca4e'
                            }
                        }
                    }, {
                        color: 'rgba(59, 144, 231, 0.2)',
                        from: 33,
                        to: 66,
                        label : {
                            text : customSettings.legend.favorableLabel,
                            verticalAlign: 'bottom',
                            useHTML: true,
                            x: -6,
                            style: {
                                fontSize: '10pt',
                                color: '#3b90e7'
                            }
                        }
                    }, {
                        color: 'rgba(0, 168, 34, 0.1)',
                        from: 66,
                        to: 100,
                        label : {
                            text : customSettings.legend.veryFavorableLabel,
                            verticalAlign: 'bottom',
                            useHTML: true,
                            x: -6,
                            style: {
                                fontSize: '10pt',
                                fontWeight: 'bold',
                                color: '#00a822'
                            }
                        }
                    }
                ]
            }
        };
    
        return super.mergeOptions(super.allChartOptions(), options);
    }
}

export default function () {registerPlugin(PercentageChart)}